import SpecTable from "./SpecTableContainer";
export default SpecTable;
